import axios from 'axios'
export default {
	data: () => ({
		logo: require('../../../../assets/logo.svg'),
		logoTitle: 'Ortica Systems',
		
		options: {
			filename: `OrticaSystems.pdf`,
			//margin: [20, 0, 10, 0], //top, left, buttom, right
			//margin: [5, 5, 5, 5], //top, left, buttom, right
			image: { type: 'jpeg', quality: 0.98 },
			enableLinks: false,
			html2canvas: {
				scale: 1,
				useCORS: true,
				//scale: 1,
				//bottom: 20
			},
			jsPDF: {
				unit: 'mm',
				format: 'a4',
				orientation: 'portrait'
			},
			pagebreak: { avoid: ['tr'] },
		},

		currentdate: new Date(),

		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення",
			onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
		},
	}),

	props: {
		code: 				{ type: String, default: 'Report' },
		name: 				{ type: String, default: 'Запити' },
		description: 		{ type: String, default: '' },
		//data: 			{ type: Object, default: () => {} },
		//parameters: 	{ type: Array, default: () => [] },
		//title: 			{ type: String, default: 'Звіт' },
		//subtitle: 		{ type: String, default: null },
		filename: 		{ type: String, default: 'Звіт.pdf' },
	},

	computed: {
		module() {
			return `Report${this.code}`
		},

		params() {
			return this.$store.getters[`${this.module}/params`]
		},

		data() {
			return this.$store.getters[`${this.module}/data`]
		},

		title() {
			return this.name
		},
		
		subtitle() {
			return this.description
		},

		parameters() {
			return [
				{ code: 'datebegin', name: 'Дата початку періоду', description: '', type: 'date', value: this.params.datebegin },
				{ code: 'dateend', name: 'Дата завершення періоду', description: '', type: 'date', value: this.params.dateend },
			]
		},
	},

	methods: {
		generate () {
			this.$refs.html2Pdf.generatePdf()
		},

		async beforeDownload ({ html2pdf, options, pdfContent }) {
			await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
				const totalPages = pdf.internal.getNumberOfPages()
				for (let i = 1; i <= totalPages; i++) {
					pdf.setPage(i)
					pdf.setFontSize(10)
					pdf.setTextColor(150)
					pdf.text('Сторінка ' + i + ' з ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
				} 
			})//.save()
		}
	},
}